import { render, staticRenderFns } from "./mineIndex.vue?vue&type=template&id=b5b3516a&scoped=true&"
import script from "./mineIndex.vue?vue&type=script&lang=js&"
export * from "./mineIndex.vue?vue&type=script&lang=js&"
import style0 from "./mineIndex.vue?vue&type=style&index=0&id=b5b3516a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b3516a",
  null
  
)

export default component.exports